const Mensagens = {
  // Mensagens gerais
  AGUARDE_PROCESSANDO: 'Aguarde, processando...',
  SELECAO_SISTEMAS: 'Selecione os sistemas que o usuário tem permissão',
  INFORMACOES_GERAIS: 'Informações Gerais',
  NENHUM_ITEM_ENCONTRADO: 'Nenhum item encontrado',
  ESQUECEU_SENHA: 'Esqueceu a senha?',
  FUNCIONALIDADE_EM_DESENVOLVIMENTO: 'Funcionalidade em desenvolvimento',
  CAMPOS_OBRIGATORIOS: 'Por favor, preencha corretamente os campos.',
  SESSAO_EXPIRADA: 'Sessão expirada, redirecionando...',
  SELECIONE_OPCAO: 'Selecione Uma Opção',

  // Nomes de sistemas
  SISTEMA_DIXI_PONTO: 'DIXI PONTO',
  SISTEMA_DIXI_ACESSOS: 'DIXI ACESSOS',
  SISTEMA_DIXI_CHAMADOS: 'DIXI CHAMADOS',
  SISTEMA_DIXI_CLIENTES: 'DIXI CLIENTES',

  //Usuário
  USUARIO: {
    CADASTRO_TITULO: 'Cadastro de Usuário',
    CADASTRO_SUBTITULO: 'Insira as informações do usuário',
    EDICAO_TITULO: 'Edição de Usuário',
    EDICAO_SUBTITULO: 'Altere as informações do usuário',
    INFO_LOGIN: 'Informações de Login',
    LOGIN_ACESSO: 'Login de acesso',
    LOGIN_PLACEHOLDER: 'Insira um login para acessar o sistema',
    SENHA: 'Senha',
    SENHA_PLACEHOLDER: 'Insira uma senha',
    SENHA_PLACEHOLDER_EDICAO: '••••••••',
    CONFIRMAR_SENHA: 'Confirmar senha',
    CONFIRMAR_SENHA_PLACEHOLDER: 'Insira uma senha novamente',
    CONFIRMAR_SENHA_PLACEHOLDER_EDICAO: '••••••••',
    NOME: 'Nome do usuário',
    NOME_PLACEHOLDER: 'Insira o nome do usuário',
    GRUPO_PERMISSAO: 'Grupo de permissão',
    EMPRESA: 'Empresa',
    CPF: 'CPF',
    CPF_PLACEHOLDER: 'ex: 123.456.789-00',
    EMAIL: 'Email',
    EMAIL_PLACEHOLDER: 'Insira um email para acessar o sistema',
    SITUACAO_CADASTRO: 'Situação cadastro',
    PERMISSOES_SUPORTE: 'Permissões de Suporte (Opcional)',

    // Mensagens de sucesso para usuário
    ATUALIZADO_SUCESSO: 'Usuário atualizado com sucesso!',
    CADASTRADO_SUCESSO: 'Usuário cadastrado com sucesso!',
    CRIADO_SUCESSO: 'Usuário criado com sucesso!',

    // Mensagens de erro para usuário
    ERRO: {
      // Erros de validação
      NOME_OBRIGATORIO: 'Nome de usuário é obrigatório.',
      NOME_MINIMO: 'Nome deve ter pelo menos 3 caracteres.',
      LOGIN_OBRIGATORIO: 'Login de acesso é obrigatório.',
      LOGIN_MINIMO: 'Login deve ter pelo menos 3 caracteres.',
      GRUPO_PERMISSAO_OBRIGATORIO: 'Grupo de Permissão é obrigatório.',
      SENHA_MINIMA: 'Senha deve ter pelo menos 4 caracteres.',
      SENHAS_NAO_COINCIDEM: 'As senhas não coincidem.',
      SENHA_OBRIGATORIA: 'Senha é obrigatória.',
      CONFIRMAR_SENHA_OBRIGATORIA: 'Confirmar senha é obrigatório.',
      CPF_INVALIDO: 'CPF inválido.',
      CPF_OBRIGATORIO: 'CPF é obrigatório.',
      EMAIL_INVALIDO: 'E-mail inválido.',
      EMAIL_OBRIGATORIO: 'E-mail é obrigatório.',
      EMPRESA_OBRIGATORIA: 'Empresa é obrigatória.',

      // Erros de API
      CARREGAR: 'Erro ao carregar usuário',
      ATUALIZAR: 'Erro ao atualizar usuário',
      ATUALIZAR_TENTE_NOVAMENTE: 'Ocorreu um erro ao atualizar o usuário. Tente novamente.',
    },

    // Mensagens para listagem de usuários
    LISTAGEM: {
      TITULO: 'Usuários',
      FILTRO_NOME: 'Nome',
      FILTRO_NOME_PLACEHOLDER: 'Digite o nome',
      FILTRO_EMAIL: 'E-mail',
      FILTRO_EMAIL_PLACEHOLDER: 'Digite o e-mail',
      FILTRO_EMPRESA: 'Empresa',
      FILTRO_SITUACAO: 'Situação Cadastro',
      COLUNA_NOME: 'Nome',
      COLUNA_SITUACAO: 'Situação',
      COLUNA_EMAIL: 'E-mail',
      COLUNA_EMPRESA: 'Empresa',
    },
  },
  // Cliente
  CLIENTE: {
    CADASTRO_TITULO: 'Cadastro de Cliente',
    CADASTRO_SUBTITULO: 'Insira as informações do cliente',
    EDICAO_TITULO: 'Edição de Cliente',
    EDICAO_SUBTITULO: 'Altere as informações do cliente',
    NOME: 'Nome do cliente',
    NOME_PLACEHOLDER: 'Insira o nome do cliente',
    CPF_CNPJ: 'CPF/CNPJ',
    CPF_CNPJ_PLACEHOLDER: 'Digite o CPF ou CNPJ do cliente',
    EMAIL: 'Email',
    EMAIL_PLACEHOLDER: 'Digite o email do cliente',
    TELEFONE: 'Telefone',
    TELEFONE_PLACEHOLDER: 'Digite o telefone do cliente',
    EMPRESA: 'Empresa',
    SITUACAO_CADASTRO: 'Situação cadastro',
    DOCUMENTO: 'Documento',
    DOCUMENTO_PLACEHOLDER: 'Digite o documento do cliente',
    RAZAO_SOCIAL: 'Razão Social',
    RAZAO_SOCIAL_PLACEHOLDER: 'Insira a razão social do cliente',
    INFORMACOES_ADICIONAIS: 'Informações Adicionais (Opcional)',
    SUBTITULO_INFORMACOES_ADICIONAIS: 'Insira as informações secundárias do cliente',
    
    // Campos de informações adicionais
    NOME_FANTASIA: 'Nome Fantasia',
    NOME_FANTASIA_PLACEHOLDER: 'Insira um nome fantasia',
    CEP: 'CEP',
    CEP_PLACEHOLDER: 'Insira o CEP',
    CIDADE: 'Cidade',
    CIDADE_PLACEHOLDER: 'Ex: São Paulo',
    ENDERECO: 'Endereço',
    ENDERECO_PLACEHOLDER: 'Insira o endereço',
    NUMERO: 'N°',
    NUMERO_PLACEHOLDER: 'Ex: 123',
    ESTADO: 'Estado',
    ESTADO_PLACEHOLDER: 'Ex: SP',
    BAIRRO: 'Bairro',
    BAIRRO_PLACEHOLDER: 'Insira o bairro',

    // Mensagens de sucesso para cliente
    ATUALIZADO_SUCESSO: 'Cliente atualizado com sucesso!',
    CADASTRADO_SUCESSO: 'Cliente cadastrado com sucesso!',

    // Mensagens de erro para cliente
    ERRO: {
      
      // Erros de validação
      NOME_OBRIGATORIO: 'Nome do cliente é obrigatório.',
      CPF_CNPJ_OBRIGATORIO: 'CPF/CNPJ é obrigatório.',
      CPF_CNPJ_INVALIDO: 'CPF/CNPJ inválido.',
      EMAIL_INVALIDO: 'E-mail inválido.',
      TELEFONE_INVALIDO: 'Telefone inválido.',
      EMPRESA_OBRIGATORIA: 'Empresa é obrigatória.',
      
      // Novas mensagens para Razão Social e Documento
      RAZAO_SOCIAL_OBRIGATORIA: 'Razão social é obrigatória.',
      RAZAO_SOCIAL_MINIMO: 'Razão social deve ter pelo menos 3 caracteres.',
      DOCUMENTO_OBRIGATORIO: 'Documento é obrigatório.',
      DOCUMENTO_INVALIDO: 'Documento inválido.',
      
      // Erros de API
      CARREGAR: 'Erro ao carregar cliente',
      ATUALIZAR: 'Erro ao atualizar cliente',
      ATUALIZAR_TENTE_NOVAMENTE: 'Ocorreu um erro ao atualizar o cliente. Tente novamente.',
    },

    LICENCA: {
      NENHUMA_CADASTRADA: 'Nenhuma licença cadastrada',
      PARA_CADASTRAR: 'Para cadastrar, clique acima em',
      ADICIONAR_LICENCA_MAIS: 'Adicionar Licença +',
      ADICIONAR_LICENCA: 'Adicionar Licença',
      ADICIONAR_LICENCA_COM_NOME: 'Adicionar Licença - {nome}',
      SELECIONE_SISTEMA: 'Selecione o sistema a ser adicionado',
      INSIRA_INFO_LICENCA: 'Insira as informações da licença',
      CADASTRO_LICENCAS: 'Cadastro de Licenças',
      EDICAO_LICENCAS: 'Edição de licenças',
      PLANO_NAO_INFORMADO: 'Plano não informado',
      COPIAR_UNIDADE_SUCESSO: 'Unidade copiada para a área de transferência!',
      COPIAR_UNIDADE_ERRO: 'Falha ao copiar unidade.',
    },

    // Mensagens para listagem de clientes
    LISTAGEM: {
      TITULO: 'Clientes',
      FILTRO_NOME: 'Nome',
      FILTRO_NOME_PLACEHOLDER: 'Digite o nome',
      FILTRO_CPF_CNPJ: 'CPF/CNPJ',
      FILTRO_CPF_CNPJ_PLACEHOLDER: 'Digite o CPF ou CNPJ',
      FILTRO_DOCUMENTO: 'Documento',
      FILTRO_DOCUMENTO_PLACEHOLDER: 'Digite o documento',
      FILTRO_EMPRESA: 'Empresa',
      FILTRO_SITUACAO: 'Situação Cadastro',
      FILTRO_LICENCAS: 'Licenças',
      FILTRO_PLANO: 'Plano',
      FILTRO_LICENCAS_ATIVAS: 'Licenças Ativas',
      FILTRO_LICENCAS_ATIVAS_PLACEHOLDER: 'Digite a quantidade de licenças ativas',
      FILTRO_LICENCAS_TOTAIS: 'Licenças Totais',
      FILTRO_LICENCAS_TOTAIS_PLACEHOLDER: 'Digite a quantidade de licenças totais',
      FILTRO_UNIDADE_NEGOCIO: 'Unidade',
      FILTRO_UNIDADE_NEGOCIO_PLACEHOLDER: 'Digite a unidade',
      RAZAO_SOCIAL: 'Razão Social',
      DOCUMENTO: 'Documento',
      LICENCAS_ATIVAS: 'Ativas',
      LICENCAS_TOTAIS: 'Totais',
      PLANO: 'Plano',
      UNIDADE_NEGOCIO: 'Unidade',
      COLUNA_NOME: 'Nome',
      COLUNA_DOCUMENTO: 'Documento',
      COLUNA_SITUACAO: 'Situação',
      COLUNA_EMAIL: 'Email',
      COLUNA_EMPRESA: 'Empresa',
      CSV_CLIENTE: 'Cliente',
      CSV_SISTEMA: 'Sistema',
      CSV_CLIENTE_TOOLTIP: 'Exporta os dados dos clientes para CSV.',
      CSV_SISTEMA_TOOLTIP: 'Exporta os dados dos sistemas para CSV.',
    },
  },

  // Empresa
  EMPRESA: {
    CADASTRO_TITULO: 'Cadastro de Empresa',
    CADASTRO_SUBTITULO: 'Insira as informações da empresa',
    EDICAO_TITULO: 'Edição de Empresa',
    EDICAO_SUBTITULO: 'Altere as informações da empresa',
    NOME_FANTASIA: 'Nome Fantasia',
    NOME_FANTASIA_PLACEHOLDER: 'Digite o nome fantasia da empresa',
    RAZAO_SOCIAL: 'Razão Social',
    RAZAO_SOCIAL_PLACEHOLDER: 'Digite a razão social da empresa',
    DOCUMENTO: 'Documento',
    DOCUMENTO_PLACEHOLDER: 'Digite o documento da empresa',
    CNPJ_PLACEHOLDER: 'Digite o CNPJ da empresa',
    EMAIL: 'Email',
    EMAIL_PLACEHOLDER: 'Digite o email da empresa',
    TELEFONE: 'Telefone',
    TELEFONE_PLACEHOLDER: 'Digite o telefone da empresa',
    SITUACAO_CADASTRO: 'Situação cadastro',

    // Mensagens de sucesso para empresa
    ATUALIZADO_SUCESSO: 'Empresa atualizada com sucesso!',
    CADASTRADO_SUCESSO: 'Empresa cadastrada com sucesso!',

    // Mensagens de erro para empresa
    ERRO: {
      
      // Erros de validação
      NOME_FANTASIA_OBRIGATORIO: 'Nome Fantasia é obrigatório.',
      RAZAO_SOCIAL_OBRIGATORIA: 'Razão Social é obrigatória.',
      DOCUMENTO_OBRIGATORIO: 'Documento é obrigatório.',
      DOCUMENTO_INVALIDO: 'Documento inválido.',
      EMAIL_INVALIDO: 'E-mail inválido.',
      TELEFONE_INVALIDO: 'Telefone inválido.',

      // Erros de API
      CARREGAR: 'Erro ao carregar empresa',
      ATUALIZAR: 'Erro ao atualizar empresa',
      ATUALIZAR_TENTE_NOVAMENTE: 'Ocorreu um erro ao atualizar a empresa. Tente novamente.',
    },

    // Mensagens para listagem de empresas
    LISTAGEM: {
      TITULO: 'Empresas',
      FILTRO_NOME_FANTASIA: 'Nome Fantasia',
      FILTRO_NOME_FANTASIA_PLACEHOLDER: 'Digite o nome fantasia',
      FILTRO_DOCUMENTO: 'Documento',
      FILTRO_DOCUMENTO_PLACEHOLDER: 'Digite o documento',
      FILTRO_SITUACAO: 'Situação Cadastro',
      COLUNA_NOME_FANTASIA: 'Nome Fantasia',
      COLUNA_RAZAO_SOCIAL: 'Razão Social',
      COLUNA_SITUACAO: 'Situação',
      COLUNA_DOCUMENTO: 'Documento',
      COLUNA_RAZAO_SOCIAL_PLACEHOLDER: 'Digite a razão social da empresa',
    },
  },

  EQUIPAMENTO: {
    REMOVER_VINCULO_SUCESSO: 'Vínculo do equipamento removido com sucesso!',
    REMOVER_VINCULO_ERRO: 'Erro ao remover vínculo do equipamento. Tente novamente.',
    MODAL_DESVINCULAR_TITULO: 'Desvincular Equipamento?',
    MODAL_DESVINCULAR_SUBTITULO: 'Tem certeza que deseja desvincular o equipamento {numeroSerie} da unidade {unidade}?',
    MODAL_DESVINCULAR_EXPLICACAO: '*Ao desvincular o equipamento, ele será inativado na unidade atual e desvinculado da clientes.',

    LISTAGEM: {
      TITULO: 'Equipamentos',
      FILTRO_NUMERO_SERIE: 'Identificador',
      FILTRO_NUMERO_SERIE_PLACEHOLDER: 'Digite o Nº de Série ou M.A.C do equipamento',
      FILTRO_UNIDADE: 'Unidade',
      FILTRO_UNIDADE_PLACEHOLDER: 'Digite a unidade do equipamento',
      FILTRO_RAZAO_SOCIAL: 'Razão Social',
      FILTRO_RAZAO_SOCIAL_PLACEHOLDER: 'Digite a razão social do cliente',
      FILTRO_DOCUMENTO: 'Documento',
      FILTRO_DOCUMENTO_PLACEHOLDER: 'Digite o documento do equipamento',
      FILTRO_SITUACAO_SISTEMA: 'Situação Sistema',
      COLUNA_NUMERO_SERIE: 'Identificador',
      COLUNA_UNIDADE: 'Unidade',
      COLUNA_RAZAO_SOCIAL: 'Razão Social',
      COLUNA_DOCUMENTO: 'Documento',
      TOOLTIP_DESVINCULAR: 'Desvincular equipamento',
      ERRO_BUSCAR: 'Erro ao buscar equipamentos:',
    },
  },

  DESENVOLVIMENTO:{
    HASH_MENSAGEM : "HASH",
    DESCRICAO : "Descrição",
    CLIENTE : "Cliente",
    REQUISICAO : "Nº de Requisições",
    HASH_MENSAGEM_CHAVE : "Hash da Chave",
    HASH_MENSAGEM_CHAVE_PLACEHOLDER : "Insira um nome ou descrição para a chave",
    UNIDADE_VINCULADA : "Unidade Vinculada",
    UNIDADE : "Unidade",
    SIT_CAD : "Situação Cadastro",
    CHAVES_DE_API : "Chaves de API",
    CADASTRO_CHAVE : "Cadastro de Chave de API",
    SUB_CADASTRO_CHAVE : "Insira as informações básicas para gerar uma chave de API.",
    EDITAR_CHAVE : "Editar Chave de API",
    SUB_EDITAR_CHAVE : "Altere as informações básicas para gerar uma chave de API.",
    LIMITES_REQUISICAO : "Limites de Requisição",
    SUBTITLO_REQ: "Insira o máximo de vezes que uma chave pode ser requisitada em determinado período.",
    DESCRICAO_LIMITE : "Insira o máximo de vezes que uma chave pode ser requisitada em determinado período.",
    LIMITE_DIARIO : "Limite Diário",
    LIMITE_SEMANAL : "Limite Semanal",
    LIMITE_MENSAL : "Limite Mensal",
    EDITAR_CHAVE : "Editar Chave de API",
    ATUALIZADO_SUCESSO: 'Chave de API atualizada com sucesso!',
    CADASTRADO_SUCESSO: 'Chave de API cadastrada com sucesso!',
    ERRO: {
      DESCRICAO_OBRIGATORIA: "A descrição é obrigatória.",
      CLIENTE_OBRIGATORIO: "O cliente deve ser selecionado.",
      UNIDADE_OBRIGATORIA: "A unidade é obrigatória.",
      LIM_DIARIO_OBRIGATORIO: "O limite diário é obrigatório.",
      LIM_DIARIO_INVALIDO: "O limite deve ser um número maior que 0",
      LIM_DIARIO_INVALIDO_MAX: "O limite deve ser   um número menor que 10000000",
      LIM_SEMANAL_OBRIGATORIO: "O limite semanal é obrigatório.",
      LIM_SEMANAL_INVALIDO: "O limite deve ser um número maior que 0",
      LIM_SEMANAL_INVALIDO_MAX: "O limite deve ser um número menor que 10000000",
      LIM_MENSAL_OBRIGATORIO: "O limite mensal é obrigatório.",
      LIM_MENSAL_INVALIDO: "O limite deve ser um número maior que 0",
      LIM_MENSAL_INVALIDO_MAX: "O limite deve ser um número menor que 10000000",
      CARREGAR: "Erro ao carregar dados da página",
      ATUALIZAR_TENTE_NOVAMENTE: 'Ocorreu um erro ao atualizar a Chave de Api. Tente novamente.',
      UNIDADE_N_ENCONTRADA: 'Unidade não encontrada para este cliente, Tente outro.',
    }
  },

  // Mensagens de erro
  ERRO: {
    
    // Erros de login/autenticação
    LOGIN_INVALIDO: 'Login inválido!',
    SENHA_INVALIDA: 'Senha inválida!',
    LOGIN_SENHA_INVALIDOS: 'Login ou senha inválidos!',

    // Erros de API
    RESPOSTA_NAO_ENCONTRADA_API: 'Erro ao processar a resposta da API: resposta não encontrada.',
    ERRO_BUSCAR_DADOS: 'Erro ao buscar dados.',
  },
};

export default Mensagens;
